<script lang="ts">
  import RequiresRetailerUserAuthentication from "@retailer/svelte/Cart/Page/DistributorSection/RequiresRetailerUserAuthentication.svelte";
  import { loginEvent } from "@shared/services/retailer_user_authentication_service";
  import { OHLQ_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let authStatus: string;
  export let authService: any;
  export let highlightErrors: boolean = false;
</script>

<div data-testid="ohlq-cart-cta">
  <RequiresRetailerUserAuthentication {authStatus} {highlightErrors}>
    <div slot="pending-title"> Want to Order High Proof Spirits & Liquor? </div>
    <div slot="invalid-description">
      <span class="fizz-text-strong"> We can’t verify your Wholesale Cloud Account: </span>
      Please call the OHLQ Liquor Enterprise Service Center at
      <a href="tel:+18778120013">877-812-0013</a>
      then verify your account with a new API Key.
    </div>

    <svelte:fragment slot="invalid-buttons">
      <a
        href="https://portal.ohlq.com/My-Account#/account"
        target="_blank"
        rel="noreferrer"
        class="fizz-button fizz-button-small"
        on:click={() => loginEvent("invalid", OHLQ_DISTRIBUTOR_ID)}>Log Into WSC</a
      >
      <a
        href={"#"}
        on:click|preventDefault={() => authService?.startVerification?.("invalid")}
        class="fizz-nowrap fizz-link fizz-text-strong">Verify Account</a
      >
    </svelte:fragment>

    <div slot="pending-description">
      Connect your Wholesale Cloud Account to shop from your local OHLQ agency store on Provi.
    </div>

    <div slot="pending-buttons">
      <button
        on:click|preventDefault={() => authService?.startVerification?.("pending")}
        class="fizz-button fizz-button-small fizz-nowrap fizz-text-strong">Connect Account</button
      >
    </div>
  </RequiresRetailerUserAuthentication>
</div>
